import {FC} from 'react'
import {App} from '../App'
import {PrivateRoutes} from './PrivateRoutes'
import {AuthPage, Logout} from '../modules/auth'
import {InviteAccept} from '../modules/account/users/components/InviteAccept'
import {usersAPI} from '../services/UsersService'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {LayoutSplashScreen} from '../template/layout/core'
import {useAppSelector} from '../hooks/redux'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'

const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {accessToken} = useAppSelector((state) => state.authReduser)
  const {isLoading, isSuccess} = usersAPI.useFetchGetMeQuery()

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='invite/accept/:token' element={<InviteAccept />} />
          {isSuccess && accessToken ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/apps/' />} />
            </>
          ) : (
            <>
              {!isLoading && (
                <>
                  <Route path='auth/*' element={<AuthPage />} />
                  <Route path='*' element={<Navigate to='/auth/' />} />
                </>
              )}
              {isLoading && (
                <>
                  <Route path='*' element={<LayoutSplashScreen />} />
                </>
              )}
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
